import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';

export default function Unauthorized() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="unauthorized-page">
      <div className="text-center max-w-md">
        <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldOff size={24} className="text-red-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Access Denied
        </h1>
        <p className="text-slate-500 mb-6 text-sm">
          You don't have permission to access this page. Contact your administrator if you believe this is an error.
        </p>
        {/* To the user's own start page. "Back" could be the page that
            refused them, and a permission revoked mid-session makes that likely. */}
        <button
          onClick={() => navigate('/', { replace: true })}
          className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-900 text-white text-sm font-medium rounded-md hover:bg-indigo-800 transition-colors"
          data-testid="go-back-button"
        >
          <ArrowLeft size={15} />
          Back to FinOps
        </button>
      </div>
    </div>
  );
}
